let _ = require("underscore");
import i18n from "../utils/i18n";
import POS from "../POS.js";
let BillModel = require("../model/BillModel.js");

let main = function (_, i18n, POS, BillModel) {

    /**
     * Two bills are at the same status.
     * @param localBill
     * @param serverBill
     */
    function mergeAtSameStatus(localBill, serverBill) {
        mergeForced(localBill, serverBill);
    }

    /**
     * The two bills are at conflicting state.
     * @param localBill
     * @param serverBill
     */
    function mergeAtConflictingStatus(localBill, serverBill) {
        mergeForced(localBill, serverBill);
    }


    /**
     * Copy attributes from server bill to local bill, overwritting any change locally.
     * @param localBill the local bill.
     * @param serverBill the server bill.
     */
    function mergeForced(localBill, serverBill) {
        var newProps = {};
        var affectedTables = [];
        affectedTables.push(POS.getTables().get(serverBill.get('table').id));

        _(serverBill.keys()).each(function (key) {
            var value = serverBill.get(key);
            switch (key) {
                case 'restaurant':
                case 'id':
                case 'uuid':
                case 'items':
                    localBill.get('items').reset(serverBill.get('items').models);
                    break;
                case 'table':
                    var currentTable = POS.getTableOfBill(localBill.id);
                    if (currentTable.id != serverBill.get('table').id) {
                        // bill has moved on another POS.
                        var targetTable = POS.getTables().get(serverBill.get('table').id);
                        currentTable.set("currentBill", new BillModel({lastUpdated: new Date().getTime()}));
                        currentTable.getBillCollection().remove(localBill);
                        targetTable.getBillCollection().add(localBill);
                        localBill.set({table: serverBill.get('table')});
                        affectedTables.push(currentTable);
                    } else {
                        newProps[key] = value;
                    }
                    break;
                case 'unconfirmedItems':
                    break;
                case 'payments':
                    localBill.get('payments').reset(serverBill.get('payments').models);
                    break;
                case 'discount':
                    if (serverBill.get('discount') == [] ) {
                        localBill.set({"discount":  null});
                    } else {
                        localBill.set({"discount":  serverBill.get('discount')});
                    }
                    break;
                default:
                    newProps[key] = value;
                    // console.log("overwriting local bill." + key + " to " + value);
            }
        });
        localBill.set(newProps);
        localBill.calculateAmount();
        localBill.calculateRefund();
        _(affectedTables).each(function(table) {
            table.refreshBillVersionTotal();
            table.refreshStatus();
        });
    }

    return {
        /**
         * Merge a local bill model with newer information from the server bill model. Reports any conflict in the bill's conflict property.
         * @param localBill model
         * @param serverBill model
         */
        merge: function (localBill, serverBill) {
            // console.log('serverBill', serverBill.toJSON());
            // console.log('localBill', localBill.toJSON());
            if (localBill.get('status') == serverBill.get('status')) {
                mergeAtSameStatus(localBill, serverBill);
            } else {
                mergeAtConflictingStatus(localBill, serverBill);
            }
        }
    }
};

let exportedValue = main(_, i18n, POS, BillModel);
export default exportedValue;



// WEBPACK FOOTER //
// ./src/recorder/BillMerger.js